import { render, staticRenderFns } from "./SelectAcademicYear.vue?vue&type=template&id=d3482fe8&scoped=true"
import script from "./SelectAcademicYear.vue?vue&type=script&lang=js"
export * from "./SelectAcademicYear.vue?vue&type=script&lang=js"
import style0 from "./SelectAcademicYear.vue?vue&type=style&index=0&id=d3482fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3482fe8",
  null
  
)

export default component.exports